<ng-container *ngFor="let job of jobs(); trackBy: trackByJobId">
  <div class="status-pill-async-wrapper">
    <div class="status-pill"
         [class.exporting]="variantFor(job.status) === 'exporting'"
         [class.warning]="variantFor(job.status) === 'warning'"
         [class.danger]="variantFor(job.status) === 'danger'"
         (click)="togglePopover(job.jobId)"
         [attr.aria-label]="labelFor(job)"
         role="button"
         tabindex="0">
      <span class="pulse-dot"></span>
      <span class="pill-text">{{ labelFor(job) }}</span>
    </div>

    <div class="job-popover" *ngIf="openedJobId() === job.jobId" (click)="$event.stopPropagation()">
      <header class="popover-header">
        <span class="popover-title">{{ job.exporterLabel }}</span>
        <button type="button" class="popover-close" (click)="closePopover()" aria-label="Cerrar">
          <svg viewBox="0 0 24 24" width="14" height="14"><path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
        </button>
      </header>

      <div class="popover-body">
        <div class="popover-row">
          <span class="row-label">Estado</span>
          <span class="row-value status-{{ job.status }}">{{ job.status }}</span>
        </div>

        <div class="popover-row" *ngIf="job.status === 'running'">
          <span class="row-label">Progreso</span>
          <div class="progress-track">
            <div class="progress-fill" [style.width.%]="job.progress * 100"></div>
          </div>
          <span class="row-value progress-pct">{{ (job.progress * 100) | number:'1.0-0' }}%</span>
        </div>

        <div class="popover-row" *ngIf="job.message">
          <span class="row-label">Mensaje</span>
          <span class="row-value">{{ job.message }}</span>
        </div>

        <div class="popover-row" *ngIf="job.createdCount != null || job.failedCount != null">
          <span class="row-label">Resultado</span>
          <span class="row-value">
            <span class="result-ok" *ngIf="job.createdCount != null">{{ job.createdCount }} creadas</span>
            <span class="result-sep" *ngIf="job.createdCount != null && job.failedCount">·</span>
            <span class="result-fail" *ngIf="job.failedCount">{{ job.failedCount }} fallidas</span>
          </span>
        </div>

        <div class="popover-row" *ngIf="job.externalUrl">
          <span class="row-label">Ver en {{ job.exporterLabel }}</span>
          <a class="row-link" [href]="job.externalUrl" target="_blank" rel="noopener noreferrer">
            Abrir ↗
          </a>
        </div>

        <div class="popover-row error-row" *ngIf="job.error">
          <span class="row-label">Error</span>
          <span class="row-value error-text">{{ job.error }}</span>
        </div>
      </div>

      <footer class="popover-footer" *ngIf="!isTerminal(job.status)">
        <button type="button" class="btn warning sm" (click)="cancelJob(job.jobId)">
          CANCELAR
        </button>
      </footer>
    </div>
  </div>
</ng-container>
